<template>
    <header class="conversation-toolbar">
        <h1>Conversation with {{ authorName || 'Unknown Author' }}</h1>
        <popup-menu v-if="ready">
            <template #activator><button class="btn">Options <span class="caret"/></button></template>
            <section class="mini-menu">
                <a @click="$emit('focus')">Show selected mention</a>
                <a @click="$emit('mentions')">See mentions</a>
                <a @click="$emit('authors')">See authors</a>
            </section>
        </popup-menu>
        <button class="btn" title="Close this view (Esc)" @click="$emit('close')">Close</button>
    </header>
</template>

<script>
import PopupMenu from '@/components/PopupMenu';
export default {
    name: 'ConversationToolbar',
    components: {PopupMenu},
    props: {authorName: String, ready: Boolean}
};
</script>

<style scoped>
.conversation-toolbar { display: flex; align-items: center; gap: 10px; padding: 12px 24px; }
h1 { flex: 1; margin: 0; font-size: 24px; }
</style>
